import React from 'react'
import ReactDOM from 'react-dom'
import './assets/scss/app.css'
import App from './App'
import Routes from './Routes'
import 'flag-icon-css/css/flag-icon.css'
import { IntlProvider, addLocaleData } from 'react-intl'
import es from './i18n/locales/es'
import esLocale from 'react-intl/locale-data/es'
import pt from './i18n/locales/pt'
import ptLocale from 'react-intl/locale-data/pt'
import en from './i18n/locales/en'
import enLocale from 'react-intl/locale-data/en'
import registerServiceWorker from './registerServiceWorker'
import ConnectedIntlProvider from './i18n'
import createBrowserHistory from 'history/createBrowserHistory'
import { Router } from 'react-router-dom'
addLocaleData([...enLocale, ...esLocale])
const history = createBrowserHistory()

const messages = {
    en,
    es,
    pt
}

let MyIntlProvider = ({ children }) => {
    const locale = 'es'

    return (
        <div>
            <Router history={history}>
                <ConnectedIntlProvider />
            </Router>
        </div>
    )
}

ReactDOM.render(<MyIntlProvider />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js